/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const AccueilType = new ObjectType({
    name: 'AccueilItem',
    description: 'Cet objet represente la page d`accueil',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la page',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la page',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la page',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la page',
            resolve: (root) => root.content.rendered
        },
        texteRealisation: {
            type: StringType,
            description: 'Le texte de la section realisation',
            resolve: (root) => root.acf.texte_section_realisation
        },
        ctaRealisation: {
            type: StringType,
            description: 'Le CTA de la section realisation',
            resolve: (root) => root.acf.cta_section_realisation
        },
        texteBlogue: {
            type: StringType,
            description: 'Le texte de la section blog',
            resolve: (root) => root.acf.texte_section_blogue
        },
        ctaBlogue: {
            type: StringType,
            description: 'Le CTA de la section blog',
            resolve: (root) => root.acf.cta_section_blogue
        },
        textePropos: {
            type: StringType,
            description: 'Le texte de la section propos',
            resolve: (root) => root.acf.texte_section_propos
        },
        ctaPropos: {
            type: StringType,
            description: 'Le CTA de la section propos',
            resolve: (root) => root.acf.cta_section_propos
        },
    }),
});

export default AccueilType;



// WEBPACK FOOTER //
// ./data/types/AccueilType.js